"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var StyledPreviewDoughnut = _styledComponents["default"].div.withConfig({
  displayName: "PreviewDoughnutstyle__StyledPreviewDoughnut",
  componentId: "sc-1afyf0w-0"
})(["", ";"], function (props) {
  var _props$theme = props.theme,
    color = _props$theme.palette,
    typography = _props$theme.typography,
    extra = _props$theme.extra;
  var isDefault = props.isDefault,
    isActive = props.isActive,
    colorScheme = props.colorScheme,
    DoughnutSize = props.DoughnutSize;
  var getDoughnutChartTrackColor = function getDoughnutChartTrackColor() {
    if (isDefault) {
      return isActive ? color.basic.white : extra.rewardsCategories["default"];
    }
    return isActive ? extra.rewardsCategories["default"] : color.gray.charlie;
  };
  var getDoughnutChartIndicatorColor = function getDoughnutChartIndicatorColor() {
    if (isDefault) {
      return isActive ? color.basic.white : extra.rewardsCategories["default"];
    }
    return isActive ? color.basic.white : colorScheme;
  };
  return (0, _styledComponents.css)([".DoughnutChart-track{fill:transparent;stroke:", ";stroke-width:26;}.DoughnutChart-indicator{fill:transparent;stroke:", ";stroke-width:26;stroke-dasharray:0 10000;transition:stroke-dasharray 0.2s ease;}.DoughnutChart{border-radius:50%;display:block;}.DoughnutChart-text{font-family:", ";fill:", ";}.DoughnutChart-text-val{font-size:", "px;font-weight:", ";}"], getDoughnutChartTrackColor(), getDoughnutChartIndicatorColor(), typography.font.primary, isActive ? color.basic.white : extra.rewardsCategories["default"], DoughnutSize * 0.45, typography.weight.strong);
});
StyledPreviewDoughnut.displayName = 'StyledPreviewDoughnut';
var _default = exports["default"] = StyledPreviewDoughnut;